/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PhotoInputs */

const cs_enum_photo = /** @type {(inputs: Enum_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie`)
};

const en_enum_photo = /** @type {(inputs: Enum_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {Enum_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_photo = /** @type {((inputs?: Enum_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_photo(inputs)
	return cs_enum_photo(inputs)
});